module.exports = __webpack_public_path__ + "static/media/a171.45324202.jpg";